import React from "react";
import AccountTypes from "../components/AccountTypes";
import BottomCTA from "../components/BottomCTA";
import PlatformHero from "../components/platform/PlatformHero";
import PlatformFeatures from "../components/platform/PlatformFeatures";
import PlatformDownloads from "../components/platform/PlatformDownloads";

export default function PlatformPage() {
    return (
        <div data-testid="platform-page">
            <PlatformHero />
            <PlatformFeatures />
            <AccountTypes />
            <PlatformDownloads />
            <BottomCTA />
        </div>
    );
}
